export class BookedQuantity {
  private _areaItemId: number;
  private _availableQuantity: number;

  constructor(
    areaItemId: number,
    availableQuantity: number,
  ) {
    this._areaItemId = areaItemId;
    this._availableQuantity = availableQuantity;
  }

  static createFromAny(object: any): BookedQuantity {
    if (object === null || object === undefined) {
      return null;
    }

    return new BookedQuantity(
      object.areaItemId,
      object.availableQuantity,
    );
  }

  get areaItemId(): number {
    return this._areaItemId;
  }

  get availableQuantity(): number {
    return this._availableQuantity;
  }

}
